import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Youtube, Instagram } from 'lucide-react';
import { navLinks, contactInfo } from '../mock';

const socialIcons = { facebook: Facebook, twitter: Twitter, youtube: Youtube, instagram: Instagram };

const Footer = () => {
  return (
    <footer className="bg-[#080b12] border-t border-white/5 pt-16 pb-8">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-12">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img src="/dctv-logo.png" alt="DCTV - Diaspora Community Television" className="h-14 w-auto object-contain" />
              <span className="leading-none">
                <span className="block text-[11px] tracking-[0.22em] text-[#c9a24a] font-semibold">DIASPORA</span>
                <span className="block text-[11px] tracking-[0.22em] text-[#9aa3b2] mt-1">COMMUNITY TV</span>
              </span>
            </div>
            <p className="text-[#9aa3b2] text-sm leading-relaxed max-w-xs">
              A multicultural media platform giving the diaspora a voice, promoting social cohesion, dialogue and self-expression through community television.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {Object.keys(socialIcons).map((s) => {
                const Icon = socialIcons[s];
                return (
                  <a key={s} href="#" onClick={(e) => e.preventDefault()} className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-[#9aa3b2] hover:text-[#e8743b] hover:border-[#e8743b]/50 transition-colors">
                    <Icon className="w-4 h-4" />
                  </a>
                );
              })}
            </div>
          </div>

          <div>
            <h4 className="dctv-eyebrow text-[#9aa3b2] mb-5">Explore</h4>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-[#cdd2dc] text-sm hover:text-[#e8743b] transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="dctv-eyebrow text-[#9aa3b2] mb-5">Contact</h4>
            <a href={`mailto:${contactInfo.email}`} className="block text-[#cdd2dc] text-sm hover:text-[#e8743b] transition-colors">{contactInfo.email}</a>
            <div className="mt-4 space-y-1">
              {contactInfo.phones.map((p) => (
                <p key={p} className="text-[#cdd2dc] text-sm">{p}</p>
              ))}
            </div>
            <p className="text-[#9aa3b2] text-sm mt-4">{contactInfo.hours}</p>
            <p className="text-[#9aa3b2] text-sm mt-2">{contactInfo.location}</p>
          </div>
        </div>

        <div className="border-t border-white/5 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[#6b7384] text-xs">© 2026 Diaspora Community Television. All rights reserved.</p>
          <p className="text-[#6b7384] text-xs">The Hague · Europe · Mainland China · Countries of origin</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
